import { ThunkApiType } from 'types/utils';
import authFetch, { checkForUnauthorizedResponse } from '../../utils/axios';

export const getMemberDetailsThunk = async (
	{
		subscriptionUuid,
		dateOfService,
	}: {
		subscriptionUuid: string;
		dateOfService: string;
	},
	thunkAPI: ThunkApiType,
) => {
	try {
		const response = await authFetch.get(
			`/member/portalMemberDetail?subscriptionUuid=${subscriptionUuid}&dateOfService=${dateOfService}`,
		);
		return { ...response.data, subscriptionUuid };
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};
